import React from "react";
import ProspectDetails from "./ProspectDetails";
import ProspectExperience from "./ProspectExperience";
import ProspectEducation from "./ProspectEducation";
import ProspectOrganization from "./ProspectOrganization";

const ExperienceEducationOrganization = ({
  profileData,
  setLoading,
  expDetails,
  eduDetails,
  organizationData,
  setOrganizationData,
  isDownloading,
  isMobile,
  isTabPortrait,
}) => {
  return (
    <div>
      <div
        style={{
          display: isMobile ? "grid" : isTabPortrait ? "grid" : "flex",
          width: "100%",
          gap: "20px",
          marginBottom: "22px",
        }}
      >
        <ProspectExperience
          profileData={profileData}
          expDetails={expDetails}
          isMobile={isMobile}
          isTabPortrait={isTabPortrait}
        />
        <ProspectEducation
          profileData={profileData}
          eduDetails={eduDetails}
          isMobile={isMobile}
          isTabPortrait={isTabPortrait}
        />
      </div>
      <div
      // style={{ pageBreakInside: "avoid", breakBefore: "page" }}
      >
        {!isMobile ? (
          <ProspectOrganization
            setLoading={setLoading}
            organizationData={organizationData}
            setOrganizationData={setOrganizationData}
            isDownloading={isDownloading}
            isTabPortrait={isTabPortrait}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default ExperienceEducationOrganization;
